import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PostContent from 'components/Presentation/PostContent';
import { getSchedule } from 'actions/schedule';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import DateTime from '_class/DateTime';
import Moment from 'moment';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import User from '_class/User';
import { Block } from '@haldor/ui';
import { getActiveSchool } from 'helpers/localstorage';
import { ColorLabel, ColorLabelContainer, Collapsible } from 'UI';
import TeacherAdjustments from 'containers/AdditionalAdjustments/Display/TeacherAdjustments';
var styles = {
  background: 'white',
  color: 'black',
  borderRadius: '6px',
  marginBottom: '0.55rem',
  padding: '0.65rem',
  cursor: 'pointer',
  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.09)',
  textDecoration: 'none',
  display: 'block'
};

var SectionInformation = /*#__PURE__*/function (_Component) {
  _inherits(SectionInformation, _Component);

  var _super = _createSuper(SectionInformation);

  function SectionInformation(props) {
    var _this;

    _classCallCheck(this, SectionInformation);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isUserOwner", function () {
      var _this$props = _this.props,
          currentUser = _this$props.currentUser,
          group = _this$props.group;

      if (currentUser == null || group == null) {
        return false;
      }

      var foundOwner = group.owners.find(function (owner) {
        return currentUser.id == owner.id;
      });

      if (foundOwner != null) {
        return true;
      }

      return false;
    });

    return _this;
  }

  _createClass(SectionInformation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.group.type != 'MENTOR_GROUP') {
        this.props.getSchedule(encodeURIComponent(Moment({
          hour: 0
        }).format('YYYY-MM-DD HH:mm:ss')), encodeURIComponent(Moment({
          hour: 23,
          minute: 59
        }).format('YYYY-MM-DD HH:mm:ss')));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var subjects = [];
      var user = new User(this.props.currentUser);
      var groupId = this.props.group.id;
      var scheduleItems = this.props.schedule.filter(function (scheduleItem) {
        if (scheduleItem.section != null) {
          return scheduleItem.section.id == groupId;
        } else {
          return null;
        }
      });

      if (this.props.currentUser.subjects != null && this.props.currentUser.subjects.length > 0) {
        this.props.currentUser.subjects.forEach(function (subject) {
          if (getActiveSchool(_this2.props.currentUser.id) == subject.schoolId) {
            subjects.push(subject);
          }
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side"
      }, /*#__PURE__*/React.createElement(Block, null, this.props.group.description ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('group-information')), /*#__PURE__*/React.createElement(PostContent, null, this.props.group.description)) : null, this.props.group.owners != null && this.props.group.owners.length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('owners')), this.props.group.owners.map(function (owner) {
        return /*#__PURE__*/React.createElement("div", {
          className: "card-meta",
          style: {
            marginRight: '0.45rem'
          },
          key: 'owner' + owner.id
        }, /*#__PURE__*/React.createElement("span", {
          "data-tooltip": "".concat(_this2.props.translate('Connected to group'), " ").concat(new DateTime(owner.connectedToSectionDate).getDateStamp())
        }, /*#__PURE__*/React.createElement("a", {
          href: "mailto:".concat(owner.email),
          style: {
            margin: 0,
            color: '#363636',
            textDecoration: 'none'
          }
        }, owner.firstName, " ", owner.lastName)));
      })) : null, !user.isStudent() && subjects.length > 0 && this.props.group.type != 'MENTOR_GROUP' && this.props.services.verdicts ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('verdicts')), subjects.map(function (userSubject) {
        var course = _this2.props.group.courses.find(function (course) {
          return userSubject.subjectCode == course.subjectCode;
        });

        if (course == null) {
          return null;
        }

        if (course.status == 'COURSE_DRAFT') {
          return null;
        }

        var schoolType = _this2.props.translate(course.typeOfSchooling);

        var title = "".concat(course.title, " ").concat(course.year != null ? course.year : '', " (").concat(schoolType, ")");
        return /*#__PURE__*/React.createElement(Link, {
          key: 'course-section' + course.id,
          to: "/groups/".concat(_this2.props.group.id, "/course/").concat(course.id)
        }, /*#__PURE__*/React.createElement(ColorLabelContainer, null, /*#__PURE__*/React.createElement(ColorLabel, {
          content: title,
          color: course.colorCode,
          style: {
            color: '#363636'
          }
        })));
      })) : null, this.props.group.type != 'MENTOR_GROUP' && this.props.services.schedule ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('todays-lessons')), scheduleItems != null ? scheduleItems.map(function (item) {
        return /*#__PURE__*/React.createElement(Link, {
          to: "/lesson/".concat(item.id),
          style: styles,
          key: "schedule-".concat(item.id)
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            fontSize: '0.8rem'
          }
        }, new DateTime(item.startTime).getTime() + ' - ' + new DateTime(item.startTime).add(item.length, 'minutes').getTime(), item.room != null ? " - ".concat(item.room) : null), /*#__PURE__*/React.createElement("strong", {
          style: {
            fontWeight: '500'
          }
        }, item.title));
      }) : null) : null, this.props.group.type == 'MENTOR_GROUP' && !user.isStudent() && this.props.services.additionalAdjustments ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('additional-adjustments')
      }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
        groupId: groupId
      }))) : null));
    }
  }]);

  return SectionInformation;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    services: state.Services.availableServices,
    currentUser: state.user.currentUser,
    schedule: state.schedule.scheduleToday
  };
}

export default connect(mapStateToProps, {
  getSchedule: getSchedule
})(SectionInformation);